/**
 * Presentation for a token with no logo of its own.
 *
 * Cheddar's own icons come from `Mint.image`, which is curated per mint and so
 * only exists for mints we custody. Origin tokens — the ones a payer reaches
 * through a swap — have no image anywhere in our data, and `GET /v0/tokens`
 * returns no icon field either.
 *
 * A third-party icon service was evaluated and deliberately rejected: it would
 * put an external request on a payment page, telling that host which token
 * every payer is about to pay with, in exchange for logos on EVM contract
 * tokens only. A lettered chip needs no network, always renders, and cannot
 * leak anything.
 */

/** Up to two characters, so the chip reads as a token rather than a glyph. */
export function tokenInitials(symbol: string): string {
  const cleaned = symbol.trim().replace(/[^A-Za-z0-9]/g, "");
  return (cleaned.slice(0, 2) || "?").toUpperCase();
}

/**
 * A stable colour per symbol, so the same token is the same colour on every
 * render and two adjacent rows are unlikely to collide. Hue only — saturation
 * and lightness are fixed so every chip stays legible against the panel and
 * none of them can come out near-white or near-black.
 */
export function tokenChipHue(symbol: string): number {
  let hash = 0;
  for (let i = 0; i < symbol.length; i += 1) {
    hash = (hash * 31 + symbol.charCodeAt(i)) % 360;
  }
  return hash;
}
